import SwiperCarousel from 'utils/swiper-carousel';

export default () => {
  const init = () => {
    const promoSlider = new SwiperCarousel('[data-promo-bar-slider]', {
      slidesPerView: 1,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
      },
      loop: true,
      navigation: {
        nextEl: '[data-promo-bar-arrow-next]',
        prevEl: '[data-promo-bar-arrow-prev]',
      },
    });

    return promoSlider;
  };

  init();
};
